import { Injectable } from '@angular/core';
import { User } from './../_models/user';
import { ApiService } from './api.service';
import { Observable, Observer, throwError } from 'rxjs';
import { tap, catchError, shareReplay, map, flatMap } from 'rxjs/operators';

interface ILoginResponse {
  status: 'success' | 'failed';
}
interface ILoginFailedResponse {
  status: 'failed';
  message: string;
}
interface ILoginSuccessResponse {
  status: 'success';
  accountname: string;
  auth_key: string;
  avatar: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly API_KEY = 'api_key';
  private readonly AVATAR = 'avatar';
  private readonly USERNAME = 'username';

  private loggedIn = false;
  private loggedInUser: User;

  constructor(private api: ApiService) {
    this.loggedInUser = new User();
    this.loggedInUser.username = localStorage.getItem(this.USERNAME) || '';
    this.loggedIn = false;
  }


  login(username: string, password: string): Observable<boolean> {
    return this.api.login(username, password)
      .pipe(// Set api key in local storage.
        map(loginResult => {
          // console.log('loggedIn result', this.loggedIn, loginResult);
          if (loginResult !== null && loginResult.status === 'success') {
            localStorage.setItem(this.API_KEY, loginResult.auth_key);
            localStorage.setItem(this.USERNAME, loginResult.accountname);
            localStorage.setItem(this.AVATAR, loginResult.avatar);
            this.loggedInUser.username = localStorage.getItem(this.USERNAME) || '';
            this.loggedIn = true;
            return true;
          }
          return false;
        }),
        catchError((error, caught) => {
          // console.log('catch login error', error, caught);
          // this.logout();
          return throwError(error);
        }),

        // Don't send key to caller, return void.
        // Reset keys if failed
        shareReplay()
      );
  }

  register(username: string, password: string, email: string): Observable<void> {
    return this.api.register(username, password, email)
      .pipe(
        // Set api key in local storage.
        map(registerResult => {
          if (!this.loggedInUser) {
            throw Error('no logged in user found');
          }
          // console.log('registerresult', registerResult);
          localStorage.setItem(this.API_KEY, registerResult.auth_key);
          localStorage.setItem(this.USERNAME, registerResult.accountname);

          this.loggedInUser.username = localStorage.getItem(this.USERNAME) || '';
          this.loggedIn = true;

          return true;

        }),
        // Don't send key to caller, return void.
        map(registerResult => {
          return;
        }),
        // Reset keys if failed
        catchError(error => {
          this.logout();
          return throwError(error);
        }),
        shareReplay()
      );
  }

  logout(): void {
    localStorage.removeItem(this.API_KEY);
    localStorage.removeItem(this.AVATAR);
    localStorage.removeItem(this.USERNAME);
  }

  storeAvatar(settings: string): Observable<any> {
    // console.log('store avatar');
    return this.api.sendAvatar(settings)
      .pipe(
        tap(x => {
          localStorage.setItem('avatar', settings);
        }),
        catchError(error => {
          console.log('error', error);
          return throwError(error);
        }));
  }

  getAvatar(): string | null {
    return localStorage.getItem('avatar');
  }

  getAvatarImage(): string {
    const settings: any = this.getAvatar();
    // console.log('/img/avatar2/Avatar_' + this.getAvatar() + '.svg');
    return '/img/avatar2/Avatar_' + this.getAvatar() + '.svg';
  }

  getApiKey(): string | null {
    return localStorage.getItem(this.API_KEY);
  }

  getUsername(): string {
    return this.loggedInUser.username;
  }
}
